<script setup lang="ts">
// import gsap from 'gsap';

import { useTexture, useRenderLoop } from '@tresjs/core';

// Shaders
// import fragmentShader from 'src/shaders/projectsFragment.glsl?raw';
// import fragmentShader from 'src/shaders/projectsFragment_polka-dot.glsl?raw';
import fragmentShader from 'src/shaders/projectsFragment_perf-dot.glsl?raw';
// import fragmentShader from 'src/shaders/csm-sincos-lines-y.fragment.glsl?raw';
//
import vertexShader from 'src/shaders/projectsVertex.glsl?raw';

// /Users/nael/projects/ptburg/client/src/assets/projects/nesy-statue.avif

const { onLoop } = useRenderLoop();

// interface ProjectsItem {
//   name: string;
//   type: string;
//   texture: string;
// }

interface Props {
  item: ProjectPreview;
  scale: number;
  wheel: number;
  itemsDistanceScroll: number;
  itemIndex: number;
  curProjectName: string;

  // isCurrentProject: boolean;
}

const props = defineProps<Props>();

const planeMeshRef = ref();

const prepareShader = async (img: string) => {
  const map = await useTexture([img]);

  return {
    vertexShader,
    fragmentShader,
    transparent: true,
    depthWrite: false,
    uniforms: {
      uTexture: { value: map },
      uTime: { value: 0 },
      uOpacity: { value: 0 },
    },
  };
};

const shader = await prepareShader(props.item.texture);

const texImg = shader.uniforms.uTexture.value.image as HTMLImageElement;

let aspect = texImg.height / texImg.width;
let planeSize = [props.scale * 1, props.scale * aspect];

if (texImg.width < texImg.height) {
  aspect = texImg.width / texImg.height;
  planeSize = [props.scale * aspect, props.scale * 1];
}

if (props.item.type === 'sep') planeSize = [0, 0];

const speed = 0.8;

const itemProgress = computed(
  () => props.wheel / props.itemsDistanceScroll - props.itemIndex,
);

const isCurrentProjectItem = computed(
  () => props.curProjectName === props.item.name,
);

const opacity = computed(() => {
  // const opacityFloatFix2 = parseFloat(
  //   (1 - (Math.abs(wheel.value) / 1000 - itemIndex.value)).toFixed(2)
  // );

  // // const opacityEase = opacityFloatFix2 + 0.7;
  // const opacityEase = easeInExpo(opacityFloatFix2 + 0.7);
  // // const opacityEase = easeInExpo(opacityFloatFix2);
  // // const opacityEase = 1;

  // return opacityEase;

  if (!isCurrentProjectItem.value) return 0;

  return 1 - itemProgress.value;
});

watch(opacity, (val) => (shader.uniforms.uOpacity.value = val));

onLoop(({ elapsed }) => {
  shader.uniforms.uTime.value = elapsed * speed;
  // shader.uniforms.uOpacity.value = opacity.value;
});

onMounted(() => {
  // itemAnimation()
  if (isCurrentProjectItem.value) {
    shader.uniforms.uOpacity.value = 1;

    // gsap.to(shader.uniforms.uOpacity, {
    //   duration: props.itemIndex * 0.4,
    //   value: 1,
    // });

    // gsap.from(planeMeshRef.value.position, {
    //   duration: 0.6,
    //   x: 0,
    //   z: -props.itemIndex * 2,
    // });
  }
});

// };
</script>

<template lang="pug">
TresMesh(
  ref="planeMeshRef"
  :name="item.name"
  )
  //- :material="item.material")
  TresPlaneGeometry(:args="[planeSize[0],planeSize[1],100,100]")
  //- TresPlaneGeometry(:args="[1,1,30,30]")
  TresShaderMaterial(v-bind="shader")
</template>

<style lang="sass"></style>
